// src/layouts/services/components/ServicesModal.jsx

import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";

// Vision UI components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";

// Componente do modal de serviços
const ServicesModal = ({ open, onClose, service }) => {
  // Se nenhum serviço estiver selecionado, não renderiza nada
  if (!service) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "#1E1F2F",
          borderRadius: "20px",
          padding: 2,
        },
      }}
    >
      {/* Título com ícone, nome do serviço e botão de fechar */}
      <DialogTitle>
  <VuiBox display="flex" justifyContent="space-between" alignItems="center">
    <VuiBox display="flex" alignItems="center" gap={1}>
      {/* Ícone com estilo aplicado */}
      <VuiBox
        sx={({ palette, borders, functions, shadows }) => ({
          backgroundColor: "#111827", // cinza escuro neutro e com contraste
          minWidth: functions.pxToRem(40),
          minHeight: functions.pxToRem(40),
          borderRadius: borders.borderRadius.button,
          display: "grid",
          placeItems: "center",
          boxShadow: shadows.md,
        })}
      >
        {service.icon}
      </VuiBox>

      {/* Título ao lado do ícone */}
      <VuiTypography variant="h5" color="white" fontWeight="bold">
        {service.title}
      </VuiTypography>
    </VuiBox>

    {/* Botão de fechar */}
    <IconButton onClick={onClose} sx={{ color: "#fff" }}>
      <CloseIcon />
    </IconButton>
  </VuiBox>
</DialogTitle>

<DialogContent>
  <VuiBox textAlign="left"> {/* Alinha o conteúdo à esquerda */}
    <VuiTypography variant="body2" color="text" mb={3}>
      {service.descriptionLong || service.description}
    </VuiTypography>

    {service.link && (
      <VuiButton
        component={Link}
        to={service.link}
        color="info"
        variant="contained"
        fullWidth
        sx={{ mt: 2 }}
        onClick={onClose}
      >
        Ver projetos relacionados
      </VuiButton>
    )}
  </VuiBox>
</DialogContent>


    </Dialog>
  );
};

export default ServicesModal;